import React from 'react'
import { NavLink, Stack, Divider, ScrollArea, Title } from '@mantine/core'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Sidebar = () => {
	const { experienceSlug } = useParams()
	const location = useLocation()

	const currentOrgName = useSelector((state) => state.user.currentOrg?.orgName)
	const orgRole = useSelector((state) => state.user.currentOrg?.orgRole)
	const position = useSelector((state) => state.experience.userPosition)
	const experience = useSelector((state) => state.experience.experienceDetails)

	const isActive = (path) => location.pathname === path
	const inAdminRoutes = location.pathname.startsWith('/admin')

	return (
		<ScrollArea style={{ height: '100%' }}>
			<Stack spacing='sm'>
				<Title order={4} fw={700}>
					{currentOrgName || 'Organization'}
				</Title>

				{orgRole === 'admin' && inAdminRoutes && (
					<>
						<NavLink
							label='Manage Users'
							active={isActive('/admin/users')}
							component='a'
							href='/admin/users'
						/>
						<NavLink
							label='Manage Experiences'
							active={isActive('/admin/experiences')}
							component='a'
							href='/admin/experiences'
						/>
					</>
				)}

				{experienceSlug && (
					<>
						<Title order={6} size='xs' c='dimmed'>
							{experience?.name || 'Experience'}
						</Title>
						{position?.level === 'owner' && (
							<NavLink
								label='Check-ins Overview'
								active={isActive(`/experiences/${experienceSlug}/overview`)}
								component='a'
								href={`/experiences/${experienceSlug}/overview`}
							/>
						)}

						<NavLink
							label='Check-in Travelers'
							active={isActive(`/experiences/${experienceSlug}`)}
							component='a'
							href={`/experiences/${experienceSlug}`}
						/>

						{experience?.allowStaffAddCheckIns &&
							experience?.status !== 'inactive' &&
							position?.level === 'staff' && (
								<NavLink
									label='Add Check-in'
									active={isActive(
										`/experiences/${experienceSlug}/manage/checkin/new`
									)}
									component='a'
									href={`/experiences/${experienceSlug}/manage/checkin/new`}
								/>
							)}

						{position?.level === 'owner' && (
							<>
								<NavLink
									label='Manage Check-ins'
									active={isActive(
										`/experiences/${experienceSlug}/manage/checkins`
									)}
									component='a'
									href={`/experiences/${experienceSlug}/manage/checkins`}
								/>
								<NavLink
									label='Manage Staff'
									active={isActive(
										`/experiences/${experienceSlug}/manage/staff`
									)}
									component='a'
									href={`/experiences/${experienceSlug}/manage/staff`}
								/>
							</>
						)}

						{orgRole === 'admin' && (
							<NavLink
								label='Experience Settings'
								active={isActive(
									`/experiences/${experienceSlug}/manage/details`
								)}
								component='a'
								href={`/experiences/${experienceSlug}/manage/details`}
							/>
						)}
						{orgRole === 'admin' && !inAdminRoutes && (
							<>
								<NavLink
									label={`Manage ` + currentOrgName}
									active={isActive('/admin/users')}
									component='a'
									href='/admin/users'
								/>
							</>
						)}
					</>
				)}
			</Stack>
		</ScrollArea>
	)
}

export default Sidebar
